export default errorHandler => async (ctx, next) => {
  try {
    await next()
  } catch (e) {
    await errorHandler(e, ctx)
  }
}
